<script lang="ts">

    import { fly } from "svelte/transition";
    import type { Game } from "../../Model/Game";
    import { isCardsBingoGame } from "../../Services/aux";
    import NumberCircle from "../Shared/NumberCircle.svelte";
    import Watch from "../Shared/Watch.svelte";
    import GameCard from "./GameCard.svelte";

    export let game: Game;

</script>

<div class="game-historic">
    <Watch state={game.numbers} let:value={gameNumbers}>
        {#each gameNumbers.slice(-4).reverse() as number, index (number)}
            <div class="number">
                <div class="number-inner" in:fly={{ x: -100 }} out:fly={{ x: 100 }}>
                    {#if isCardsBingoGame(game.type)}
                        <GameCard {number} gameType={game.type} />
                    {:else}
                        <NumberCircle featured={index == 0} {number} />
                    {/if}
                </div>
            </div>
        {/each}
    </Watch>
</div>

<style lang="scss">

    $featured-width: 35%;
    $historic-width: 65% * 0.333;
    $historic-left: $historic-width * 0.5;

    .game-historic {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .number {
        position: absolute;
        top: 50%;
        height: calc(100% - 10px);
        transform: translate(-50%, -50%);
        transition-duration: 0.5s;

        :global(img) {
            max-width: 100%;
            max-height: 100%;
        }
    }

    .number-inner {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .number:nth-child(1) {
        width: $featured-width - 3%;
        left: $featured-width * 0.5;
        z-index: 2;
    }

    .number:nth-child(1) ~ .number {
        width: $historic-width - 3%;
    }

    .number:nth-child(2) {
        left: $featured-width + $historic-left;
    }

    .number:nth-child(3) {
        opacity: 0.75;
        left: $featured-width + $historic-left + $historic-width;
    }

    .number:nth-child(3) ~ .number {
        opacity: 0.5;
        left: $featured-width + $historic-left + ($historic-width * 2);
    }

</style>
